import { useState } from "react";
import { LoginForm } from "./LoginForm.jsx";
import { SignupForm } from "./SignupForm.jsx";
import { ForgotPasswordForm } from "./ForgotPasswordForm.jsx";

export function AuthScreen({ onAuthenticated }) {
  const [audience, setAudience] = useState("business"); // business | casual
  const [mode, setMode] = useState("login"); // login | signup | signup-done | forgot | forgot-done

  function switchAudience(next) {
    setAudience(next);
    setMode("login");
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#F5F6FA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          padding: 32,
          width: "100%",
          maxWidth: 400,
        }}
      >
        <div style={{ fontWeight: 900, fontSize: 20, color: "#735DFF", letterSpacing: 1, marginBottom: 16 }}>
          SANNAMAI
        </div>

        <div style={{ display: "flex", gap: 4, marginBottom: 24, background: "#F5F6FA", borderRadius: 10, padding: 4 }}>
          <button
            onClick={() => switchAudience("business")}
            style={{
              flex: 1,
              padding: "8px 0",
              borderRadius: 8,
              border: 0,
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 700,
              background: audience === "business" ? "#fff" : "transparent",
              color: audience === "business" ? "#735DFF" : "#383853",
              boxShadow: audience === "business" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
            }}
          >
            Verslo paskyra
          </button>
          <button
            onClick={() => switchAudience("casual")}
            style={{
              flex: 1,
              padding: "8px 0",
              borderRadius: 8,
              border: 0,
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 700,
              background: audience === "casual" ? "#fff" : "transparent",
              color: audience === "casual" ? "#735DFF" : "#383853",
              boxShadow: audience === "casual" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
            }}
          >
            Asmeninė paskyra
          </button>
        </div>

        {mode === "login" && (
          <LoginForm
            audience={audience}
            onSuccess={onAuthenticated}
            onForgotPassword={() => setMode("forgot")}
            onGoToSignup={() => setMode("signup")}
          />
        )}

        {mode === "signup" && (
          <SignupForm audience={audience} onSuccess={() => setMode("signup-done")} onGoToLogin={() => setMode("login")} />
        )}

        {mode === "signup-done" && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: "#1C1C1C", marginBottom: 8 }}>
              Patikrinkite savo el. paštą
            </h2>
            <p style={{ fontSize: 14, color: "#383853", marginBottom: 16 }}>
              Išsiuntėme jums patvirtinimo nuorodą. Paspauskite ją, tada galėsite prisijungti.
            </p>
            <button
              onClick={() => setMode("login")}
              className="px-4 py-2 text-sm font-semibold rounded-lg bg-ral3000 text-white hover:bg-ral3000-dark"
            >
              Grįžti į prisijungimą
            </button>
          </div>
        )}

        {mode === "forgot" && (
          <ForgotPasswordForm audience={audience} onSuccess={() => setMode("forgot-done")} onGoToLogin={() => setMode("login")} />
        )}

        {mode === "forgot-done" && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: "#1C1C1C", marginBottom: 8 }}>
              Patikrinkite savo el. paštą
            </h2>
            <p style={{ fontSize: 14, color: "#383853", marginBottom: 16 }}>
              Jei toks el. pašto adresas egzistuoja, išsiuntėme slaptažodžio atstatymo nuorodą.
            </p>
            <button
              onClick={() => setMode("login")}
              className="px-4 py-2 text-sm font-semibold rounded-lg bg-ral3000 text-white hover:bg-ral3000-dark"
            >
              Grįžti į prisijungimą
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
